import React from 'react';
import { ProcessingContainer, ProcessingHeader, ProcessingItem, MediaIcon, ProcessingBody, ProcessingName, StatusBadge, ProcessingSpinner, ProgressBarContainer, ProgressBar, ProgressBarFill, ProgressDescription, ErrorText, RemoveProcessingButton } from './styles/index';
/**
 * 처리 중인 미디어 표시 컴포넌트
 * 아직 처리 중이거나 오류가 발생한 미디어를 보여줍니다.
 */ var ProcessingView = function(param) {
    var processingMedia = param.processingMedia, onRemove = param.onRemove, _param_isSubmitting = param.isSubmitting, isSubmitting = _param_isSubmitting === void 0 ? false : _param_isSubmitting;
    if (!processingMedia.length) return null;
    return /*#__PURE__*/ React.createElement(ProcessingContainer, null, /*#__PURE__*/ React.createElement(ProcessingHeader, null, "미디어 처리 중"), processingMedia.map(function(item, index) {
        var _item_processingProgress;
        var progress = (_item_processingProgress = item.processingProgress) !== null && _item_processingProgress !== void 0 ? _item_processingProgress : 0;
        var isProcessing = item.status === 'processing';
        var isError = item.status === 'error';
        return /*#__PURE__*/ React.createElement(ProcessingItem, {
            key: "processing-item-".concat(item.id || index)
        }, /*#__PURE__*/ React.createElement(MediaIcon, {
            "aria-hidden": "true"
        }, item.type === 'video' ? /*#__PURE__*/ React.createElement("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "20",
            height: "20",
            viewBox: "0 0 20 20",
            fill: "currentColor"
        }, /*#__PURE__*/ React.createElement("path", {
            fillRule: "evenodd",
            d: "M4 5a2 2 0 00-2 2v6a2 2 0 002 2h12a2 2 0 002-2V7a2 2 0 00-2-2h-1.586a1 1 0 01-.707-.293l-1.121-1.121A2 2 0 0011.172 3H8.828a2 2 0 00-1.414.586L6.293 4.707A1 1 0 015.586 5H4z",
            clipRule: "evenodd"
        }), /*#__PURE__*/ React.createElement("path", {
            d: "M8 7a1 1 0 011-1h2a1 1 0 110 2H9a1 1 0 01-1-1z"
        })) : /*#__PURE__*/ React.createElement("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "20",
            height: "20",
            viewBox: "0 0 20 20",
            fill: "currentColor"
        }, /*#__PURE__*/ React.createElement("path", {
            fillRule: "evenodd",
            d: "M4 3a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V5a2 2 0 00-2-2H4zm12 12H4l4-8 3 6 2-4 3 6z",
            clipRule: "evenodd"
        }))), /*#__PURE__*/ React.createElement(ProcessingBody, null, /*#__PURE__*/ React.createElement(ProcessingName, null, item.type === 'video' ? '비디오 처리 중' : '이미지 처리 중', isError && /*#__PURE__*/ React.createElement(StatusBadge, null, "오류")), isProcessing && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(ProgressBarContainer, null, progress === 0 && /*#__PURE__*/ React.createElement(ProcessingSpinner, {
            "aria-hidden": "true"
        }), /*#__PURE__*/ React.createElement(ProgressBar, null, /*#__PURE__*/ React.createElement(ProgressBarFill, {
            progress: progress
        }))), /*#__PURE__*/ React.createElement(ProgressDescription, null, progress ? "".concat(progress, "% 완료됨") : '처리 중...')), isError && item.errorMessage && /*#__PURE__*/ React.createElement(ErrorText, null, item.errorMessage)), onRemove && !isSubmitting && /*#__PURE__*/ React.createElement(RemoveProcessingButton, {
            type: "button",
            onClick: function() {
                return onRemove(index);
            },
            "aria-label": "처리 중인 미디어 삭제"
        }, /*#__PURE__*/ React.createElement("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "14",
            height: "14",
            viewBox: "0 0 20 20",
            fill: "currentColor"
        }, /*#__PURE__*/ React.createElement("path", {
            fillRule: "evenodd",
            d: "M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z",
            clipRule: "evenodd"
        }))));
    }));
};
export default ProcessingView;
